module.exports = __webpack_public_path__ + "static/img/shareimg.312895d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgwx/dlact2/shareimg.png
// module id = LEiP
// module chunks = 6